import MultiSelect from '@dc-shared-web/components/base/MultiSelect'
import { PROVISIONS } from '@dc-shared-web/components/features/AIConfigDialog/constants'
import { AIConfigModalValues } from '@dc-shared-web/components/features/AIConfigDialog/types'
import { useGetAllProvisions } from '@dc-shared-web/hooks/api/provision'

const ProvisionsRow = ({
  values,
  disabled,
  onChange,
}: {
  values: AIConfigModalValues
  disabled?: boolean
  onChange: (values: AIConfigModalValues) => void
}) => {
  const handleChange = (value: { value: string; label: string }[]) => {
    onChange({ ...values, provisions: value.map((v) => parseInt(v.value)) })
  }

  const { data } = useGetAllProvisions()

  const allProvisions =
    data?.results.map((p) => ({
      label: p.text,
      value: p.fid.toString(),
    })) ??
    PROVISIONS.map((p) => ({
      label: p.name,
      value: p.kira_field_id.toString(),
    }))

  return (
    <div className='tw-flex tw-flex-col tw-gap-1'>
      <p className='tw-text-sm'>Provisions</p>
      <MultiSelect
        options={allProvisions}
        placeholder='Select provisions...'
        disabled={disabled}
        onValueChange={handleChange}
        value={values.provisions.map((id) => ({
          label:
            allProvisions.find((p) => p.value === id.toString())?.label || '',
          value: id.toString(),
        }))}
      />
    </div>
  )
}

export default ProvisionsRow
